import "../../../assets/css/demo.css";
import { Typography } from "antd";
import React, { Component } from "react";

class ContractConditions extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "start",
          width: this.props.isMobile ? "100%" : "80%",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {this.props.isMobile ? (
            <Typography
              style={{
                margin: "10px 0px",
                fontWeight: "bold",
                fonSize: "10px",
              }}
            >
              CONDICIONES GENERALES DE CONTRATACIÓN del Servicio de Transmisión
              de Datos y Acceso a Internet de Nadunet Telecom SL
            </Typography>
          ) : (
            <Typography.Title
              level={5}
              style={{
                margin: "10px 0px",
              }}
            >
              CONDICIONES GENERALES DE CONTRATACIÓN del Servicio de Transmisión
              de Datos y Acceso a Internet de Nadunet Telecom SL
            </Typography.Title>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            className="contract-conditions"
            style={{ textAlign: "justify", fonSize: 8 }}
            dangerouslySetInnerHTML={{
              __html: this.props.contractCondition.text,
            }}
          />
        </div>
      </div>
    );
  }
}

export default ContractConditions;



// WEBPACK FOOTER //
// ./src/views/Contract/components/ContractConditions.jsx